import { v4 as uuidv4 } from "uuid";

const TAB_ID_KEY = "__neoconecta_tab_id__";

let tabId = sessionStorage.getItem(TAB_ID_KEY);
if (!tabId) {
  tabId = uuidv4();
  sessionStorage.setItem(TAB_ID_KEY, tabId);
}

export const TAB_ID = tabId;
export const SESSION_ID = uuidv4();